import { HttpClient } from '@angular/common/http';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { combineLatest, Subject } from 'rxjs';
import { map, takeUntil, tap } from 'rxjs/operators';
import { Provenienza } from 'src/app/common/models/tipologiche/provenienza';
import { TipoDocumento } from 'src/app/common/models/tipologiche/tipo-documento';
import {
  FileFolders,
  TreeModel
} from '../../../../../common/components/fascicolo/documentazione-allegata-view/documentazione-allegata.component';
import { IdDescrittoriDiSezione } from '../../../../../common/configuration/nomi-descrittori-sezione';
import { DescrittoreSezione } from '../../../../../common/models/descrittore-sezione';
import { DocumentoAllegato } from '../../../../../common/models/documento-allegato';
import { Fascicolo } from '../../../../../common/models/fascicolo/fascicolo';
import { Pratica } from '../../../../../common/models/pratica/pratica';
import { Sezione } from '../../../../../common/models/sezioni/sezione';
import { TipoSezione } from '../../../../../common/models/tipologiche/tipo-sezione';
import { ServicePathsSettings } from '../../../../../core/configuration/service-paths-settings';
import { HelpersService } from '../../../../../core/services/helpers.service';
import { OperationsService } from '../../../../../core/services/operations.service';
import { ViewManagerService } from '../../../../../core/services/view-manager-service';
import { CreazionePraticaStoreService } from '../../services/creazione-pratica-store.service';
import { CreazionePraticaTipologicheService } from '../../services/creazione-pratica-tipologiche.service';
import { CreazionePraticaService } from '../../services/creazione-pratica.service';

@Component({
  selector: 'app-step-documentazione-allegata',
  templateUrl: './step-documentazione-allegata.component.html',
  styleUrls: ['./step-documentazione-allegata.component.css']
})
export class StepDocumentazioneAllegataComponent implements OnInit, OnDestroy {

  tipiDocumento: TipoDocumento[] = [];
  tipiProvenienza: Provenienza[] = [];

  navigatorTreeModel: TreeModel;
  navigatorItemSuggested: FileFolders;
  navigatorItemSelected: FileFolders;
  navigatorItemMoving: FileFolders;
  navigatorRefreshData: boolean;
  navigatorPathSeparator: string;
  navigatorAddDocFromTitle: string[];
  navigatorState = STEP_DOCUMENTAZIONE_ALLEGATA_NAVIGATOR_STATE;
  navigatorStateValue: STEP_DOCUMENTAZIONE_ALLEGATA_NAVIGATOR_STATE = STEP_DOCUMENTAZIONE_ALLEGATA_NAVIGATOR_STATE.DETAILS;
  navigatorSezioni: Sezione[];
  navigatorDocumentazione: {
    documentiElaborazione: DocumentoAllegato[],
    documentiFascicolo: DocumentoAllegato[]
  }

  private pratica: Pratica;
  private fascicolo: Fascicolo;

  private componentDestroyed$: Subject<void> = new Subject<void>();

  constructor(
    private tipologicheService: CreazionePraticaTipologicheService,
    private creazionePraticaService: CreazionePraticaService,
    private creazionePraticaStoreService: CreazionePraticaStoreService,
    private operationsService: OperationsService,
    private helpersService: HelpersService,
    private viewManagerService: ViewManagerService,
    private http: HttpClient,
  ) {
    this.creazionePraticaStoreService.pratica$.pipe(takeUntil(this.componentDestroyed$)).subscribe(it => this.pratica = it)
    this.creazionePraticaStoreService.fascicolo$.pipe(takeUntil(this.componentDestroyed$)).subscribe(it => this.fascicolo = it);
  }

  ngOnInit() {
    this.initNavigator();
    this.getTipiDocumento()
    this.getTipiProvenienza()
  }

  ngOnDestroy() {
    this.componentDestroyed$.next();
  }

  getTipiDocumento() {
    this.tipologicheService.getTipiDocumenti().pipe(takeUntil(this.componentDestroyed$)).subscribe(response => {
      this.tipiDocumento = response && response.length > 0 ? (response.sort((a, b) => (a.label < b.label) ? -1 : 1)) : []
    });
  }

  getTipiProvenienza() {
    this.tipologicheService.getTipiProvenienzaDocumento().pipe(takeUntil(this.componentDestroyed$)).subscribe(response => {
      this.tipiProvenienza = (<Provenienza[]>response)
    });
  }

  initNavigator() {
    console.log('[initNavigator]', '---');

    this.navigatorTreeModel = new TreeModel(
      'code',
      'name',
      'children',
      [],
      null,
      true,
      'Navigazione',
      'navigator-tree-data',
      'glyphicon-folder-close',
      'glyphicon-folder-open',
      'glyphicon-file'
    );
    this.navigatorPathSeparator = "/";
    this.navigatorAddDocFromTitle = [];
    this.navigatorDocumentazione = {
      documentiElaborazione: [],
      documentiFascicolo: []
    }
    this.navigatorItemSelected = null;
    this.navigatorItemMoving = null;
    this.navigatorRefreshData = false;

    // TSR-491 ----------------------
    let descrittoreTipoPratica = this.pratica.tipoPratica.descrizione.toLowerCase();

    switch (descrittoreTipoPratica) {
      case "amministrativo":
        descrittoreTipoPratica = ServicePathsSettings.NOME_BE_PRATICA_AMMINISTRATIVA;
        break;
      case "autorita' amministrative indipendenti":
        descrittoreTipoPratica = ServicePathsSettings.NOME_BE_PRATICA_AUTORITA_INDIPENDENTE;
        break;
      case "pareristico":
        descrittoreTipoPratica = ServicePathsSettings.NOME_BE_PRATICA_PARERISTICA;
        break;
    }
    // ----------------------

    combineLatest([
        this.helpersService.getDescrittoriFascicolo(descrittoreTipoPratica, this.pratica.tipoPratica.id, this.fascicolo.tipoFascicolo.id)
          .pipe(
            tap(descrittori => console.log('[initNavigator]', 'Descrittori:', descrittori))
          ),
        this.helpersService.getMenuFascicolo(this.pratica.tipoPratica.id, this.fascicolo.tipoFascicolo.id).pipe(
          tap(menu => console.log('[initNavigator]', 'Menu:', menu)),
          map(menu => menu.lowerListIns.find(it => it.id === 'documentazione_allegata_fascicolo'))
        ),
        this.creazionePraticaStoreService.documentazioneElaborazione$.pipe(
          tap(documentazioneElaborazione => console.log('[initNavigator]', 'Documentazione Elaborazione:', documentazioneElaborazione)),
        ),
        this.creazionePraticaStoreService.documentazioneAllegata$.pipe(
          tap(documentazioneAllegata => console.log('[initNavigator]', 'Documentazione Allegata:', documentazioneAllegata)),
        )
      ]
    ).pipe(
      takeUntil(this.componentDestroyed$)
    ).subscribe(([descrittori, menu, documentazioneElaborazione, documentazioneAllegata]) => {
      if (documentazioneAllegata == null) {
        this.creazionePraticaStoreService.setDocumentazioneAllegata([]);
        return;
      }

      this.navigatorDocumentazione.documentiElaborazione = documentazioneElaborazione;
      this.navigatorDocumentazione.documentiFascicolo = documentazioneAllegata;
      this.navigatorSezioni = this.createNavigatorSezioni(
        descrittori.filter(it => menu.descrittori.includes(it.entitySimpleName))
      );
      console.log('[initNavigator]', 'Sezioni:', this.navigatorSezioni);

      this.updateNavigator();
    });
  }

  updateNavigator() {
    // console.log('[updateNavigator]', '---');
    // console.log('[updateNavigator]', 'TreeModel:', this.navigatorTreeModel);
    // console.log('[updateNavigator]', 'ItemSelected:', this.navigatorItemSelected);
    // console.log('[updateNavigator]', 'RefreshData:', this.navigatorRefreshData);

    let previousItemSelected = this.navigatorItemSelected;

    this.updateNavigatorRefreshData(false);
    this.updateNavigatorItemSelected(null);
    this.updateNavigatorItemSuggested(null);


    this.navigatorTreeModel = new TreeModel(
      this.navigatorTreeModel.cid,
      this.navigatorTreeModel.lid,
      this.navigatorTreeModel.cnid,
      [],
      this.navigatorTreeModel.className,
      this.navigatorTreeModel.showTitle,
      this.navigatorTreeModel.treeTitle,
      this.navigatorTreeModel.treeNodeId,
      this.navigatorTreeModel.iconExpand,
      this.navigatorTreeModel.iconCollapse,
      this.navigatorTreeModel.iconNeutral
    );

    this.navigatorSezioni.forEach(sezione => {
      this.addNavigatorFolder(sezione)
    });

    // TODO: remove when implementing more than one section
    if (!previousItemSelected) {
      this.updateNavigatorItemSelected(this.navigatorTreeModel.items[0]);
    } else {
      this.updateNavigatorItemSelected(
        this.findNavigatorItemFromPath(
          previousItemSelected.section.nomeCampoId,
          previousItemSelected.path
        ).item
      )
    }

    this.updateNavigatorItemSuggested(
      this.navigatorTreeModel.items.find(it => it.section.esn.endsWith("DocumentazioneElaborazione"))
    );
  }

  updateNavigatorItemSelected(value: FileFolders | any) {
    // console.log('[updateNavigatorItemSelected]', value)
    this.navigatorItemSelected = value;
  }

  updateNavigatorItemSuggested(value: FileFolders | any) {
    // console.log('[updateNavigatorItemSuggested]', value)
    this.navigatorItemSuggested = value;
  }

  updateNavigatorRefreshData(value: boolean | any) {
    // console.log('[updateNavigatorRefreshData]', value)
    this.navigatorRefreshData = value;
  }

  onClickAddFolder(event: any) {
    // console.log("[onClickAddFolder]", "---", event);
    this.navigatorStateValue = STEP_DOCUMENTAZIONE_ALLEGATA_NAVIGATOR_STATE.ADD_FOLDER;
  }

  onClickAddDocument(event: any) {
    // console.log("[onClickAddDocument]", "---", event);
    this.navigatorStateValue = STEP_DOCUMENTAZIONE_ALLEGATA_NAVIGATOR_STATE.ADD_DOCUMENT;
  }

  onClickMoveDocument(event: any) {
    console.log("[onClickMoveDocument]", "---", event, "Not Implemented Yet!");
  }

  onClickRemoveDocument(event: FileFolders) {
    // console.log("[onClickRemoveDocument]", "---", event);

    event.section.documenti = event.section.documenti.filter((it: DocumentoAllegato) => it.nomeFile !== event.documento.nomeFile)
    let documentazioneAllegata = this.creazionePraticaStoreService.getFascicoloTemp().documentazioneAllegata.filter((it: DocumentoAllegato) => it.nomeFile !== event.documento.nomeFile);
    this.creazionePraticaStoreService.setDocumentazioneAllegata(documentazioneAllegata);
    this.creazionePraticaStoreService.save();
    this.updateNavigator();
  }

  onDragMoveDocument(event: FileFolders | any) {
    // console.log("[onDragMoveDocument]", "---", event);
    this.navigatorItemMoving = event
  }

  onDropMoveDocument(event: FileFolders | any) {
    // console.log("[onDropMoveDocument]", "---", event);
    if (this.navigatorItemMoving) {
      this.navigatorItemMoving.documento.nomeFile = event.documento.nomeFile + this.navigatorPathSeparator + this.navigatorItemMoving.name;

      this.creazionePraticaStoreService.save();

      this.updateNavigator();

      this.navigatorItemMoving = null;
    }
  }

  onGoSectionRoot(sectionRootId) {
    this.updateNavigatorItemSelected(
      this.findNavigatorItemFromPath(sectionRootId, "").item
    )
    // this.updateNavigatorRefreshData(true);
  }

  onGoSectionChild({ sectionRootId, itemPath }) {
    this.updateNavigatorItemSelected(
      this.findNavigatorItemFromPath(sectionRootId, itemPath).item
    )
    // this.updateNavigatorRefreshData(true);   / > a > b > c
  }

  onAddDocument(documenti: DocumentoAllegato[]) {
  if (documenti?.length) {
    documenti.forEach(doc => {
      doc.nomeFile = (
        this.navigatorItemSelected.path ? this.navigatorItemSelected.path + this.navigatorPathSeparator : ''
      ) + doc.nomeFile;

      this.navigatorDocumentazione.documentiFascicolo.push(doc);
    });

    this.creazionePraticaStoreService.save();
    this.initNavigator();
  }

  this.navigatorStateValue = STEP_DOCUMENTAZIONE_ALLEGATA_NAVIGATOR_STATE.DETAILS;
}


  onReset() {
    console.log("[onReset]", "---");
    this.creazionePraticaStoreService.setDocumentazioneAllegata([]);
    this.creazionePraticaStoreService.save();
  }

  private createNavigatorSezioni(descrittori: DescrittoreSezione[]) {
    let sezioni: Sezione[] = [];
    let descrittoriSezione = IdDescrittoriDiSezione.TutteLeSezioni;

    descrittori.push({
      entitySimpleName: 'SezioneDocumentazioneElaborazione',
      writable: false,
      readable: true
    })
    if (!descrittoriSezione.find(it => it.esn === 'SezioneDocumentazioneElaborazione')) {
      descrittoriSezione.push({
        nomeSezione: 'documentazione elaborazione',
        esn: 'SezioneDocumentazioneElaborazione',
        nomeCampoId: 'idSezioneDocumentazioneElaborazione',
        nomeCampoEntityList: 'documentiElaborazione'
      })
    }

    descrittori.forEach(descrittore => {
      // console.log('[createSezioni]', 'Descrittore: ', descrittore);
      if (!descrittore.readable) {
        return;
      }
      if (descrittore.entitySimpleName !== "SezioneDocumentazioneElaborazione" && descrittore.entitySimpleName !== "SezioneDocumentazioneAllegata") {
        return;
      }

      descrittoriSezione
        .filter(it => it.esn === descrittore.entitySimpleName)
        .forEach(descrittoreSezione => {
          // console.log('[createSezioni]', 'DescrittoreSezione: ', descrittoreSezione);
          sezioni.push(
            this.createNavigatorSezione({ ...descrittore, ...descrittoreSezione })
          );
        });
    });

    return sezioni;
  }

  private createNavigatorSezione(descrittore: any){
    // console.log("[createNavigatorSezione]", "---", descrittore)
    let sezione: Sezione | any = new Sezione();

    sezione.esn = descrittore.esn;
    sezione.nomeSezione = descrittore.nomeSezione.replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase());
    sezione.nomeCampoId = descrittore.nomeCampoId;
    sezione.tipoSezione = new TipoSezione();

    sezione.isMain = descrittore.nomeCampoId.endsWith('DocumentazioneAllegata');
    sezione.writable = descrittore.writable;

    sezione.praticaId = this.pratica.id;
    sezione.tipoPraticaId = this.pratica.tipoPratica.id;
    sezione.posizionePratica = this.pratica.posizione;

    sezione.fascicoloId = this.fascicolo.id;
    sezione.posizioneFascicolo = this.fascicolo.posizione;

    sezione.entities = false;
    sezione[descrittore.nomeCampoEntityList] = [];

    if (descrittore.nomeCampoId.endsWith('DocumentazioneElaborazione')) {
      sezione.nomeSezione = "Documentazione Elaborazione";
      sezione.documenti = this.navigatorDocumentazione.documentiElaborazione;
    } else if (descrittore.nomeCampoId.endsWith('DocumentazioneAllegata')) {
      sezione.nomeSezione = "Documentazione Fascicolo";
      sezione.documenti = this.navigatorDocumentazione.documentiFascicolo;
    } else {
      sezione.documenti = [];
    }

    return sezione;
  }

  private addNavigatorFolder(sezione: Sezione) {
    // Creates and adds root folder to tree data.
    let rootFolder = new FileFolders(
      sezione.nomeSezione,
      sezione.nomeCampoId,
      [],
      true,
      '',
      null,
      null,
      sezione
    )
    this.navigatorTreeModel.items.push(rootFolder);

    // console.log('rootFolder', rootFolder.name, rootFolder);

    // Exits if folder not contains documents.
    if (!sezione.documenti) return;

    // Wraps and adds documents to root folder.
    sezione.documenti
      .forEach(document => {
        // console.log('document', document.nomeFile, document);
        if (!document) {
          return;
        }

        let fileParent = rootFolder;

        // Splits path in elements and iterates each one for build the structure links parent to children.
        document.nomeFile
          .split(this.navigatorPathSeparator)
          .forEach((fileName, index, array) => {
            // console.log('path', fileName);

            let file = fileParent.children.find(it => it.name == fileName)

            if (!file) {
              fileParent.children.push(
                file = new FileFolders(
                  fileName,
                  '',
                  [],
                  false,
                  '',
                  '',
                  null,
                  sezione
                )
              );
            }

            if (index == array.length - 1) {
              file.code = document.id;
              file.path = document.nomeFile;
              file.dateMod = document.dataAggiornamento ? document.dataAggiornamento.toString() : undefined;
              file.documento = document;
              file.section = sezione;
            } else {
              fileParent = file;
            }
          });
      });
  }

  private findNavigatorItemFromPath(sezioneId: string, path: string) {
    // console.log("[findNavigatorItemFromPath]", "---", {sezioneId, path});

    let navigatorItemParent = this.navigatorTreeModel.items.find(it => it.code == sezioneId);
    let navigatorItem = navigatorItemParent;

    path.split(this.navigatorPathSeparator).forEach(pathElement => {
      console.log("[findNavigatorItemFromPath]", `(${pathElement})`, {parent: navigatorItemParent, item: navigatorItem});
      navigatorItem.children.forEach(file => {
        if (file.name === pathElement && (file.documento && !file.documento.refDocumentale)) {
          navigatorItemParent = navigatorItem;
          navigatorItem = file;
        }
      })
    });

    return {
      parent: navigatorItemParent,
      item: navigatorItem
    };
  }
}

export enum STEP_DOCUMENTAZIONE_ALLEGATA_NAVIGATOR_STATE {
  DETAILS,
  ADD_FOLDER,
  ADD_DOCUMENT
}
